'use strict';

(function () {
  var videoThumbs = document.querySelectorAll('.column__video');

  if (!videoThumbs.length) {
    return;
  }

  videoThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function (e) {
      var videoWrap = thumb.querySelector('.video__wrap');
      var videoEmbed = videoWrap.querySelector('iframe');

      if (!videoWrap || !videoEmbed) {
        return;
      }

      videoEmbed.src += '&autoplay=1';
      setTimeout(function () {
        videoWrap.classList.add('video-is-playing');
      }, 300); // Delay to allow video to start
    });
  });
})();